/**
 * Default settings for our framer-motion animations.
 */
export const MAGIC_FLAG_SETTINGS = {
  QUERY_PARAM_KEY: "magicFlags",
};
